export enum TrendingColors {
  Now = '#4F5A9F',
  Then = '#C4CBCF',
}
